// removed by extract-text-webpack-plugin
module.exports = {"total-expense-label":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailTotalExpense-__ShiftDetailTotalExpense___3-T6Y","total-expense-amount":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailTotalExpense-__ShiftDetailTotalExpense___1UEc9"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailTotalExpense/ShiftDetailTotalExpense.css
// module id = 2230
// module chunks = 0